import { Profile } from "../../profiles/models/Profile";

export const INITIAL_VALUES: Profile = {
	ProfileId: null,
	ProfileName: "",
};
